const ordersStrings = {
  ordersHeader: {
    allOrdersFilterItem: 'All Orders',
    createOrdersButton: 'Create Order',
    ordersFilterSearchBarPlaceholder: 'Order ID, Mobile number',
  },

  ordersList: {
    orderGridNoResultsFound: 'No results matching your search criteria',
    orderGridHeader: {
      orderNumberGridHeader: 'Order #',
      orderStatusGridHeader: 'Status',
      orderDateGridHeader: 'Date',
      orderPatientGridHeader: 'Patient',
      orderChannelGridHeader: 'Channel',
      orderPromoGridHeader: 'Promo Code',
      ordertotalGridHeader: 'Total',
      orderLabGridHeader: 'Lab and Chemist',
    },
    orderGridItemElapsed(hours, minutes) {
      return `Elapsed ${hours}h:${minutes} min`;
    },
    orderGridItemCount: 'Items',
    loyaltyPointsStickerText: 'Vezeeta Points',
  },

  orderDetailsHeader: {
    orderId: 'Order #',
    viewBtnText: 'Start Preparation',
    processedBtnText: 'Preparation Completed',
    resultsDoneBtnText: 'All Results Uploaded',
    scheduleBtnText: 'Schedule',
    cancelBtnText: 'Cancel Order',
    actionPopupTitle(status) {
      return `Are you sure you want to mark this order as ${status} ?`;
    },
    actionPopupYesBtn: 'Yes',
    actionPopupNoBtn: 'No',
    scheduleOrderTitle: 'Schedule Order',
    scheduleOrderDateLabel: 'Date',
    scheduleOrderTimeLabel: 'Time',
    scheduleOrderReasonTitle: 'Schedule order reason',
    scheduleOrderReasons: {
      patientRequest: 'Patient Request',
      fulfillmentIssue: 'Fulfillment Issue',
      patientUnreachable: 'Patient Unreachable',
      businessDevelopmentOrder: 'Business Development Order',
    },
    scheduleOrderInsuranceTitle: 'Health Insurance Company',
    scheduleOrderInsuranceSystemDown: 'Online System Down',
    scheduleOrderNoteTitle: 'Notes',
    scheduleOrderNotePlaceholder: 'Write your comments',
    scheduleOrderSaveBtn: 'Save',
    scheduleOrderCancelBtn: 'Cancel',
    scheduleOrderReasonIsRequired: 'Reason Is Required',
    cancelOrderTitle: 'Cancel Order',
    cancelOrderReasonTitle: 'Cancel Order reason',
    cancelOrderReasonIsRequired: 'Reason Is Required',
  },

  orderDetailsContent: {
    noDataPlaceholder: 'No Data',
    orderScheduledDate: 'Scheduled to:',
    orderSource: 'from',
    externalKey: 'External Key',
    resolveBadge: 'Resolve with Customer',
    timeoutBadge: 'Near Time-Out',
    insuranceSticker: 'Sub-Account',
    copiedToClipboardText: 'Copied to clipboard 🚀',
    patientDetailsTitle: 'Patient Details',
    patientDetailsName: 'Patient Name',
    patientUserDetailsTitle: 'User Details',
    patientUserDetailsName: 'User Name',
    patientUserDetailsPhoneNumber: 'Phone Number',
    patientUserDetailsAge: 'Age',
    patientUserDetailsGender: 'Gender',
    patientUserDetailsGenderMale: 'Male',
    patientUserDetailsGenderFemale: 'Female',
    addressDetailsTitle: 'Shipping Address',
    addressDetailsLabel: 'Address Label',
    addressDetailsPatientName: 'Recipient Name',
    addressDetailsPhoneNumber: 'Phone Number',
    addressDetailsName: 'Address',
    addressDetailsBuilding: 'Building #',
    addressDetailsFlat: 'Flat #',
    addressDetailsStreet: 'Street Name',
    addressDetailsArea: 'Area',
    entityDetailsTitle: 'Entity Details',
    entityDetailsLabName: 'Lab Name',
    entityDetailsChemistName: 'Chemist Name',
    insuranceDetailsTitle: 'Insurance Details',
    insuranceDetailsCompanyName: 'Company name',
    insuranceDetailsCardHolder: 'Card holder',
    insuranceDetailsPatientInsId: 'Patient Ins. ID',
    insuranceDetailsBirthDate: 'Birth Date',
    insuranceDetailsIdExpiryDate: 'ID Expiry Date',
    orderLogsTitle: 'Order Logs',
    orderLogsEntry(orderNumber, logStatus, assignedToText) {
      return `Order #${orderNumber} changed to ${logStatus} ${
        assignedToText && `to ${assignedToText}`
      }`;
    },
    orderLogsUser(actionUser, logDate, logTime) {
      return `${actionUser && `By ${actionUser}`} ${logDate} at ${logTime}`;
    },
    orderScheduled(logDate, logTime) {
      return `${'To'} ${logDate} at ${logTime}`;
    },
    orderLabDropdownTitle: 'Lab',
    orderLabDropdownPlaceholder: 'Please select a lab',
    orderChemistDropdownPlaceholder: 'Please select a Chemist',
    orderChemistDropdownTitle: 'Chemist',
    orderAttachmentInfoTitle: 'Requsted item',
    orderAttachmentInfoFrom: 'from',
    orderInvoiceTitle: 'Products',
    orderInvoiceFilterOriginal: 'Original',
    orderInvoiceFilterDispensed: 'Dispensed',
    orderInvoiceFilterReturned: 'Returned',
    orderInvoiceFilterComparison: 'Comparison',
    orderInvoiceGridHeader: {
      invoiceItemGridHeader: 'Item',
      invoicePriceGridHeader: 'Price',
      invoiceQuantityGridHeader: 'Quantity',
      invoiceSubTotalGridHeader: 'Sub Total',
      invoiceDiscountGridHeader: 'Discount',
      invoiceTotalGridHeader: 'Total',
    },
    orderInvoiceDetailsLabTitle: 'Lab',
    orderInvoiceDetailsChemistTitle: 'Chemist',
    orderInvoiceDetailsSubtotalLabel(subTotalAmount) {
      return `Subtotal: ${subTotalAmount} EGP`;
    },
    orderInvoiceDetailsDeliveryFeeLabel(deliveryFeeAmount) {
      return `Delivery Fee: ${deliveryFeeAmount} EGP`;
    },
    orderInvoiceDetailsDiscountLabel(discountAmount) {
      return `Discount: ${discountAmount} EGP`;
    },
    orderInvoiceDetailsTotalLabel(totalAmount) {
      return `Total: ${totalAmount} EGP`;
    },
    orderInvoiceDetailsInsuranceLabel: 'Insuranced Order',
    orderInvoiceDetailsPromocodePlaceholder: 'PromoCode',
    orderInvoiceDetailsPromoCodeLabel(promocodeId, discountAmount) {
      return `Promo code (${promocodeId}): ${discountAmount}`;
    },
    orderInvoiceDetailsVezeetaPointsLabel(pointsCount, discountAmount) {
      return `Vezeeta Points (${pointsCount} points): ${discountAmount}`;
    },
    orderInvoiceDetailsVezeetaPointsLabelWithoutPoints(discountAmount) {
      return `Vezeeta Points: -${discountAmount} EGP`;
    },
    orderInvoiceSearchBarPlaceholder: 'Search and add an item',
    orderInvoiceServicesNoResultText: 'No results found',
    orderInvoiceServicesCurrency: 'EGP',
    orderInvoiceBtn: 'Save Invoice',
    orderAttachResultsTitle: 'Results',
    orderAttachResultsCopyToClipboardText: 'Click to copy link',
    orderAttachResultsBtnText: 'Upload and Send',
    orderNoteTitle: 'Note',
    orderNoteTextAreaPlaceholder: 'Write your comments',
    orderNoteBtnText: 'Send',
    orderPromoCodeIsInvalid: 'Promo code is invalid',
    visitNote: 'Visit note',
  },
};

export default ordersStrings;
